import ApiUtils from '@/utils/api/ApiUtils'
import S0901Const from './S0901Const'

const storeConst = S0901Const.storeConst
const store = {
  state: {
    policyContent: {

    }
  },
  actions: {
    async doRead ({ commit, state }, payload) {
      const res = await ApiUtils.postData({
        data: [{ api: storeConst.ACTION.doRead.api, input: payload }]
      })

      state.policyContent = res[0].output

      return res
    }
  }
}
export default S0901Const.getStore(store)
